<template>
  <div class="listing-popover" @mousedown.stop>
    <div class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.price.label') }}</p>
      <div class="listing-price-range">
        <div class="listing-price-range__field">
          <span>€</span>
          <input
            inputmode="numeric"
            maxlength="7"
            :placeholder="t('listing-search.price.min')"
            :aria-label="t('listing-search.price.min-aria')"
            :value="criteria.pmin"
            @input="update({ pmin: $event.target.value.replace(/\D/g, '') })"
            @keydown.enter.prevent="emit('next')"
          />
        </div>
        <span class="listing-price-range__sep">–</span>
        <div class="listing-price-range__field">
          <span>€</span>
          <input
            inputmode="numeric"
            maxlength="7"
            :placeholder="t('listing-search.price.max')"
            :aria-label="t('listing-search.price.max-aria')"
            :value="criteria.pmax"
            @input="update({ pmax: $event.target.value.replace(/\D/g, '') })"
            @keydown.enter.prevent="emit('next')"
          />
        </div>
      </div>
    </div>

    <div class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.price.frequently-chosen') }}</p>
      <div class="listing-pills">
        <button
          v-for="range in ranges"
          :key="range.label"
          type="button"
          class="listing-pill"
          :class="{ 'is-on': isActive(range) }"
          @click="pickRange(range)"
        >
          {{ range.label }}
        </button>
      </div>
    </div>

    <div class="listing-popover__footer">
      <button type="button" class="listing-link-button" @click="update({ pmin: '', pmax: '' })">
        {{ t('listing-search.clear') }}
      </button>
      <button
        v-if="skippable"
        type="button"
        class="listing-link-button listing-link-button--muted"
        @click="emit('next')"
      >
        {{ t('listing-search.skip') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useCriteria } from '../lib/useCriteria';
import { t } from '../lib/i18n';

defineProps({
  skippable: { type: Boolean, default: false }
});

const emit = defineEmits(['next']);

const { criteria, update } = useCriteria();

// Hardcoded price steps, actualised per WHN-2170.
const ranges = [
  { label: '€ 350–450k', pmin: '350000', pmax: '450000' },
  { label: '€ 450–550k', pmin: '450000', pmax: '550000' },
  { label: '€ 550–700k', pmin: '550000', pmax: '700000' },
  { label: t('listing-search.price.from', { price: '€ 700k' }), pmin: '700000', pmax: '' }
];

const isActive = (range) =>
  String(criteria.pmin || '') === range.pmin && String(criteria.pmax || '') === range.pmax;

const pickRange = (range) => {
  update({ pmin: range.pmin, pmax: range.pmax });
  emit('next');
};
</script>
